import Grid from "../widgets/grid/grid.vue";
import Restful from '../../assets/ts/restful';
import NewForm from '../forms/newform/newForm.vue';
import ModalDelegation from './modals/ModalDelegation.vue';

export default {
    data() {
        return {
            direction: payload.currentLocale.IsRightToLeft,
            columns: [
                {field: "SourceId", menu: false, hidden: true},
                {field: "DestinationId", menu: false, hidden: true},
                {
                    field: "DestinationTitle",
                    title: this.$t("delegation_management.delegate_to"),
                    filterable: false,
                    sortable: true
                },
                {
                    field: "FromDate",
                    title: this.$t("delegation_management.start_date"),
                    filterable: false,
                    sortable: true
                },
                {
                    field: "ToDate",
                    title: this.$t("delegation_management.finish_date"),
                    filterable: false,
                    sortable: true
                }
            ],
            schema: {
                data: "Data",
                total: function (response) {
                    return response.Total;
                }
            },
            toolbar: this.buildToolbarItems(),
            modalData: {},
            currentModalComponent: "",
            showDelegationModal: 0,
            reloadGrid: 0
        }
    },
    methods: {
        buildToolbarItems() {
            let mapping = (value) => {
                let hasSubActions = Array.isArray(value.subActions);
                return {
                    type: hasSubActions ? "splitButton" : "button",
                    text: (value.icon) ? `<i class="${value.icon} fa-fw fa-lg"></i> ${value.text}` : value.text,
                    enable: value.enable,
                    click: value.action,
                    imageUrl: value.image,
                    menuButtons: hasSubActions ? value.subActions.map(mapping) : undefined
                }
            };
            return this.getActions().map(mapping);
        },
        getActions() {
            return [
                {
                    key: "AddNewDelegation",
                    text: this.$t("delegation_management.delegation_create"),
                    icon: "far fa-plus-square",
                    action: (node, nodeData, selecteds) => {
                        this.modalData.isCreation = true;
                        this.currentModalComponent = "ModalDelegation";
                        this.modalData.callback = () => {
                            this.reLoadeData();
                        };
                        this.showDelegationModal++;
                    },
                    enable: true
                },
                {
                    key: "EditDelegation",
                    text: this.$t("edit"),
                    icon: "far fa-edit",
                    action: (node, nodeData, selecteds) => {
                        let dataItem = nodeData[0];
                        this.modalData.isCreation = false;
                        this.modalData.id = dataItem.DestinationId;
                        this.modalData.label = dataItem.DestinationTitle;
                        this.currentModalComponent = "ModalDelegation";
                        this.modalData.callback = () => {
                            this.reLoadeData();
                        };
                        this.showDelegationModal++;
                    },
                    enable: false
                },
                {
                    key: "DeleteDelegation",
                    text: this.$t("remove"),
                    icon: "far fa-trash-alt",
                    action: (node, nodeData, selecteds) => {
                        let dataItem = nodeData[0];
                        var id = dataItem.DestinationId;

                        var that = this;

                        confirm(i18n.$t("are_you_sure"), {
                            yes: function () {
                                var url = "api/delegations/delete/" + id;

                                that.doAjaxRequest(url, {}, () => {
                                    that.reLoadeData();
                                }, () => {
                                }, 'DELETE');
                            },
                            no: function () {
                            }
                        });
                    },
                    enable: false
                }
            ];
        },
        reLoadeData() {
            this.reloadGrid++;
        },
        doAjaxRequest(url, data, onSuccess, onFailure, method) {
            let ajaxConfig = {
                url: url,
                data: data,
                dataType: "json",

                contentType: "application/json;charset=utf-8"
            };

            ajaxConfig.beforeSend = (xhr) => {
                xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
            };

            if (method) {
                ajaxConfig.method = method;
            }

            $.ajax(ajaxConfig)
                .done((result) => {
                    if (typeof onSuccess === 'function')
                        onSuccess(result);
                }).error((error) => {
                console.log(error);
                if (typeof onFailure === 'function')
                    onFailure();
            });
        }
    },
    created() {
        var that = this;

        this.doAjaxRequest(
            "api/delegations/load-data", {},
            (data) => {
                that.modalData.baseInfo = data;
            });
    },
    components: {
        Grid,
        NewForm,
        ModalDelegation
    }
};
